/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Options } from './Options';
import {
    OptionsFromJSON,
    OptionsFromJSONTyped,
    OptionsToJSON,
    OptionsToJSONTyped,
} from './Options';
import type { Permission } from './Permission';
import {
    PermissionFromJSON,
    PermissionFromJSONTyped,
    PermissionToJSON,
    PermissionToJSONTyped,
} from './Permission';
import type { DomainMinimal } from './DomainMinimal';
import {
    DomainMinimalFromJSON,
    DomainMinimalFromJSONTyped,
    DomainMinimalToJSON,
    DomainMinimalToJSONTyped,
} from './DomainMinimal';

/**
 * 
 * @export
 * @interface WsDomain
 */
export interface WsDomain {
    /**
     * The domain associated with this workspace domain entry
     * @type {DomainMinimal}
     * @memberof WsDomain
     */
    domain: DomainMinimal;
    /**
     * List of permissions granted on this domain
     * @type {Array<Permission>}
     * @memberof WsDomain
     */
    permissions: Array<Permission>;
    /**
     * Options/settings for this domain within the workspace
     * @type {Options}
     * @memberof WsDomain
     */
    options: Options;
}

/**
 * Check if a given object implements the WsDomain interface.
 */
export function instanceOfWsDomain(value: object): value is WsDomain {
    if (!('domain' in value) || value['domain'] === undefined) return false;
    if (!('permissions' in value) || value['permissions'] === undefined) return false;
    if (!('options' in value) || value['options'] === undefined) return false;
    return true;
}

export function WsDomainFromJSON(json: any): WsDomain {
    return WsDomainFromJSONTyped(json, false);
}

export function WsDomainFromJSONTyped(json: any, ignoreDiscriminator: boolean): WsDomain {
    if (json == null) {
        return json;
    }
    return {
        
        'domain': DomainMinimalFromJSON(json['domain']),
        'permissions': ((json['permissions'] as Array<any>).map(PermissionFromJSON)),
        'options': OptionsFromJSON(json['options']),
    };
}

export function WsDomainToJSON(json: any): WsDomain {
    return WsDomainToJSONTyped(json, false);
}

export function WsDomainToJSONTyped(value?: WsDomain | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'domain': DomainMinimalToJSON(value['domain']),
        'permissions': ((value['permissions'] as Array<any>).map(PermissionToJSON)),
        'options': OptionsToJSON(value['options']),
    };
}

